import React from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const ManagerIn = ({
  strings,
  handleManagerIn,
  handlePrev,
  onChange,
  state,
  error,
}) => {
  const userIdFeedBack = error ? !!('userId' in error && error.userId) : null;
  const serialFeedBack = error ? !!('serial' in error && error.serial) : null;
  const loginFeedBack = error ? !!('login' in error && error.login) : null;
  const inputComplete =
    state.userId &&
    state.serial &&
    state.serial.length > 7 &&
    !serialFeedBack &&
    !userIdFeedBack;

  const handleKeyUp = (e) => {
    const { key, keyCode } = e;
    if (inputComplete && (key === 'Enter' || keyCode === 13)) {
      handleManagerIn();
    }
  };

  return (
    <Container sx={{ margin: 'auto' }} maxWidth="xs">
      <Card>
        <CardContent>
          <Stack
            sx={{ width: '100%', alignItems: 'center', padding: '16px 0' }}
            spacing={2}
          >
            <Typography variant="h6">{strings.title}</Typography>
            <Stack
              sx={{ width: '80%', alignSelf: 'center', padding: '16px 0' }}
              spacing={2}
            >
              <TextField
                name="userId"
                label={strings.userIdLabel}
                helperText={strings.userIdPlaceholder}
                value={state.userId}
                onBlur={onChange}
                onChange={onChange}
                onKeyUp={handleKeyUp}
                error={userIdFeedBack}
              />
              <TextField
                name="serial"
                label={strings.serialLabel}
                helperText={strings.serialPlaceholder}
                value={state.serial}
                onBlur={onChange}
                onChange={onChange}
                onKeyUp={handleKeyUp}
                error={serialFeedBack}
              />
            </Stack>
            {loginFeedBack && (
              <Alert severity="error" sx={{ margin: '16px 0' }}>
                {error.login}
              </Alert>
            )}
            <Box sx={{ width: '80%', paddingTop: '16px' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleManagerIn}
                fullWidth
              >
                로그인
              </Button>
              <Divider sx={{ margin: '16px 0' }} />
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handlePrev}
                fullWidth
              >
                뒤로
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ManagerIn;
